import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-unsubscribe-modal',
  templateUrl: './unsubscribe-modal.component.html',
  styleUrls: ['./unsubscribe-modal.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class UnsubscribeModalComponent implements OnInit {
  status: any;
  unSubMaps: any;
  unSubscribeArray: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog
  ) {
    //modal if no checkbox is checked to unsub map
  }

  ngOnInit(): void {
    this.status = this.data.message;
    this.unSubMaps = this.data.maps;
    this.unSubscribeArray = this.data.id;
  }

  noActionDIalog(): void {
    this.dialog.closeAll();
  }
}
